import { Component, OnInit, ViewChild } from '@angular/core';
import { PackageSaleService } from '../../../service/api/builk/package-sale.service';
import { PageChangedEvent } from 'ngx-bootstrap';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { formatDate } from '@angular/common';
import { TaxInvoiceModalComponent } from '../shared/tax-invoice-modal/tax-invoice-modal.component';
import { SaleCustomCostcodeTransactionListModel, SaleCustomCostcodeTransactionListQueryModel, SaleCustomCostcodeTransactionModel } from '../../../model/builk/custom-costcode-sale/sale-custom-costcode-transaction.model';
import { CustomCostCodeService } from '../../../service/api/builk/custom-costcode.service';
import { ExternalSaleTransactionListModel, ExternalSaleTransactionModel } from '../../../model/builk/custom-costcode-sale/external-sale-transaction.model';
import { SaleTransactionListQueryModel } from '../../../model/builk/package-sale/sale-transaction.model';
import { ConfirmModalComponent } from '../../shared/confirm-modal/confirm-modal.component';
import { SuccessModalComponent } from '../shared/success-modal/success-modal.component';

@Component({
  selector: 'app-custom-costcode',
  templateUrl: './custom-costcode.component.html',
  styleUrls: ['./custom-costcode.component.scss']
})
export class CustomCostCodeComponent implements OnInit {

  //ViewChild
  @ViewChild("confirmModal") confirmModal: ConfirmModalComponent;
  @ViewChild("successModal") successModal: SuccessModalComponent;

  // string
  searchText: string = '';
  tab: string = 'now';

  // boolean
  isLoading: boolean = false;
  isError: boolean = false;
  isExporting: boolean = false;
  isNow: boolean = true;
  isCustom: boolean = false;
  isApprove: boolean = false;

  // model
  queryModel: SaleTransactionListQueryModel = new SaleTransactionListQueryModel();
  transactionModel: ExternalSaleTransactionListModel = new ExternalSaleTransactionListModel();
  selectToConfirm: ExternalSaleTransactionModel;

  // array
  itemList: Array<ExternalSaleTransactionModel> = new Array<ExternalSaleTransactionModel>();
  transactionType: Array<{ value: any, label: string }> = [
    { value: 1, label: "Created" },
    { value: 2, label: "Waiting" },
    { value: 3, label: "Success" },
    { value: -1, label: "Fail" },
    { value: -10, label: "Cancel" },
  ];
  periodDate: Array<Date> = [];

  // number
  transactionTypeValue: number = 3;

  // rxjs
  private inputChange: Subject<string> = new Subject<string>();
  private subscription: Subscription;

  constructor(
    private customCostCodeService: CustomCostCodeService
  ) { }

  ngOnInit() {
    this.initData();
    this.getSaleTransaction();
    this.subscription = this.inputChange.pipe(debounceTime(1000)).subscribe((keyword: string) => { // search after typing delay 1 sec
      this.onSearch(keyword);
    });
  }

  initData() {
    this.queryModel.pageNumber = 1;
    this.queryModel.pageSize = 10;
    this.queryModel.sortByDesc = true;
    this.queryModel.sortColumn = 'PaymentDate';
    this.queryModel.textSearch = '';
    this.queryModel.status = this.transactionTypeValue;
  }

  getSaleTransaction() {
    this.isLoading = true;
    this.isError = false;
    this.customCostCodeService.getExternalSaleTransaction(this.queryModel).subscribe(res => {
      this.transactionModel = res;
      this.itemList = res.itemList;
      this.isLoading = false;
    }, err => {
      console.log(err.message);
      this.isLoading = false;
      this.isError = true;
    });
  }

  onFilterChange() {
    this.queryModel.status = this.transactionTypeValue;
    this.getSaleTransaction();
  }

  onPageChange(event: PageChangedEvent) {
    this.queryModel.pageNumber = event.page;
    this.getSaleTransaction();
  }

  getMethodType(method: number): string {
    let reposne = "";
    switch (method) {
      case 1:
        reposne = "Cash";
        break;
      case 2:
        reposne = "Credit";
        break;
      default:
        reposne = "None"
        break;
    }

    return reposne;
  }

  getTime(dateTime: Date): string {
    const now = new Date(dateTime);
    const hours = now.getHours().toString().padStart(2, '0');
    const minutes = now.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  }

  onKeywordChange() {
    if(this.queryModel.textSearch != this.searchText) {
      // keyword has change
      this.inputChange.next(this.searchText);
    }
  }

  onSearch(keyword: string) {
    this.queryModel.textSearch = keyword;
    this.queryModel.pageNumber = 1;
    this.getSaleTransaction();
  }

  onBtnCustom(val: boolean) {
    this.isCustom = val;
    if (this.isCustom == false) {
      this.isNow = true;
      this.isCustom = false;
      this.queryModel.startDate = undefined;
      this.queryModel.endDate = undefined;
      this.getSaleTransaction();
    } else {
      this.isNow = false;
      this.isCustom = true;
      if (this.periodDate.length == 0) {
        this.periodDate = [];
        let dateTime = new Date();
        this.periodDate.push(new Date(dateTime.getFullYear(), dateTime.getMonth(), 1))
        this.periodDate.push(new Date(dateTime.getFullYear(), dateTime.getMonth() + 1, 0))
        this.queryModel.startDate = this.periodDate[0];
        this.queryModel.endDate = this.periodDate[1];
      }
      this.getSaleTransaction();
    }
  }

  onDateChange() {
    if (this.isCustom) {
      this.isNow = false;
      this.queryModel.startDate = this.periodDate[0];
      this.queryModel.endDate = this.periodDate[1];
      this.getSaleTransaction();
    } else {
      this.isNow = true;
      this.queryModel.startDate = undefined;
      this.queryModel.endDate = undefined;
      this.getSaleTransaction();
    }
  }

  openConfirm(val: ExternalSaleTransactionModel) {
    this.selectToConfirm = val;
    this.confirmModal.show();
  }

  confirm() {
    if (this.selectToConfirm) {
      this.isApprove = true;
      this.customCostCodeService.approvePaymentAndSetCostCode(this.selectToConfirm).subscribe(res => {
        if (res && res > 0) {
          this.successModal.openSuccessModal(true);
          this.getSaleTransaction();
        } else {
          alert('Error at this time, try again later.');
        }
        this.isApprove = false;
      })
    }
  }
}
